'use strict'

if (module.hot) {
  module.hot.accept()
}

// import 'babel-polyfill'
// polyfills:
import './polyfills/object_assign.js'

// style
import '../styles/index.scss'

// riot init
import '../scripts/riot_setup.js'

// visualization component
import '../components/measurement-viz.tag'

// main function to render viz
import renderViz from './render_viz.js'

// this should later go into the script tag
renderViz({})
// window.renderViz = renderViz



// WEBPACK FOOTER //
// ./src/scripts/index.js